import delegate from 'delegate'

// Opens external links in new tabs

const safelist = [
  window.location.host,
  'collection.carnegieart.org',
  'collection-carnegieart.netlify.app',
  'sales.carnegiemuseums.org',
  'mailto:',
  'data:text',
  'javascript:',
  new RegExp('/^#/'),
  new RegExp('/.pdf$/')
]

export default function () {
  delegate(document.body, 'a[href]', 'click', (e) => {
    const href = e.delegateTarget.href

    // Check to see if the href matches any of the safelist patterns
    const defaultBehavior = safelist.some(safeitem => {
      if (safeitem instanceof RegExp) {
        return safeitem.test(href)
      } else {
        return href.includes(safeitem) 
      }
    })

    // As long as it does not, open the link in a new tab
    if (!defaultBehavior) {
      e.preventDefault()
      e.stopPropagation()
      window.open(href, '_blank')
    }
  })
}
